import { render } from "./CapaDetail.vue?vue&type=template&id=c86ec20a"
import script from "./CapaDetail.vue?vue&type=script&lang=js"
export * from "./CapaDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__